var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1739 8.24428L7.41647 5.48838L10.1724 2.73248C10.7025 2.20393 10.7025 1.34368 10.1724 0.815126C9.64227 0.281926 8.78512 0.283476 8.25502 0.813576L5.49757 3.56948L2.74012 0.810476C2.21002 0.280376 1.35132 0.283476 0.821217 0.810476C0.292667 1.34058 0.292667 2.20083 0.821217 2.72938L3.58022 5.48838L0.827417 8.23963C0.297317 8.76973 0.297317 9.62998 0.827417 10.157C1.09247 10.4236 1.43812 10.5553 1.78532 10.5553C2.13407 10.5553 2.47972 10.4236 2.74477 10.1585L5.49757 7.40573L8.25657 10.1632C8.52162 10.4282 8.86727 10.56 9.21447 10.56C9.56167 10.56 9.90887 10.4267 10.1739 10.1632C10.704 9.63308 10.704 8.77438 10.1739 8.24428Z",
    fill: "#979999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCancel);
export default __webpack_public_path__ + "static/media/modalCancel.ba3a7841cfb80dca9061a618ca420532.svg";
export { ForwardRef as ReactComponent };